import { useEffect } from 'react';
import { ThemeProvider } from 'styled-components';
import {
  ThemeProvider as MuiThemeProvider,
  StyledEngineProvider,
  Theme,
} from '@mui/material';
import GlobalStyle from '../style/global';
import defaultTheme from '../style/theme';

type Props = {
  children: React.ReactNode;
  theme?: Theme;
};

const useFontStylesheet = (href: string) => {
  useEffect(() => {
    if (!href || document.head.querySelector(`link[href="${href}"]`)) {
      return;
    }
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
  }, [href]);
};

const AppProviders = ({ children, theme = defaultTheme }: Props) => {
  useFontStylesheet(theme.tokens.components.globalStyle.fontStylesheet);

  return (
    <StyledEngineProvider injectFirst>
      <MuiThemeProvider theme={theme}>
        <ThemeProvider theme={theme}>
          <GlobalStyle />
          {children}
        </ThemeProvider>
      </MuiThemeProvider>
    </StyledEngineProvider>
  );
};

export default AppProviders;
